import { Component, OnDestroy, OnInit } from '@angular/core';
import { OrganizationsService } from '../../../../services/organizations/organizations.service.js';
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTabsModule } from '@angular/material/tabs';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { DCIMetrics } from 'allai-admin-shared';
import { OverlayModule } from '@angular/cdk/overlay';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { OrganizationsFilterService } from '../../../../services/organizations/organizations-filter.service.js';

import { CommonModule, PercentPipe } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';

/** The organization metric page */
@Component({
	selector: 'app-organization-dci-metrics',
	imports: [
		MatIconModule,
		MatButtonModule,
		MatTabsModule,
		MatTableModule,
		MatDatepickerModule,
		MatFormFieldModule,
		FormsModule,
		MatInputModule,
		MatTableModule,
		ReactiveFormsModule,
		OverlayModule,
		MatCardModule,
		MatExpansionModule,
		MatListModule,
		MatProgressBarModule,
		CommonModule,
		PercentPipe

	],
	providers: [provideNativeDateAdapter()],
	templateUrl: './organization-dci-metrics.component.html',
	styleUrl: './organization-dci-metrics.component.scss'
})
export class OrganizationDCIMetricsComponent implements OnInit, OnDestroy {

	dateRangeControl: FormGroup;

	dciMetrics: DCIMetrics;

	constructor(private organizationsService: OrganizationsService, private organizationsFilterService: OrganizationsFilterService) {

	}

	ngOnInit() {

		this.dateRangeControl = new FormGroup({
	    start: new FormControl<Date | null>(this.organizationsFilterService.metricsStartDate),
  	  end: new FormControl<Date | null>(this.organizationsFilterService.metricsEndDate)
	  });
		this.dateRangeControl.valueChanges.subscribe((value) => this.organizationsFilterService.metricsRange = value);

		this.organizationsService.onNewOrganizationDetail.subscribe(() => {
			this.refresh();
		});
	}

	private refresh() {
		let organizationDetail = this.organizationsService.organizationDetail;
		this.dciMetrics = organizationDetail.dciMetrics;
	}

	ngOnDestroy() {
	}
}
